var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondazioneElis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "vctheme-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.51 37.65",
    width: 200,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#005172",
    "data-name": "Rettangolo 3",
    x: 68.44,
    width: 10.65,
    height: 37.59
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005172",
    "data-name": "Tracciato 198",
    d: "M120.51,32.48a5.09,5.09,0,0,0-1.3-3.41l-7-8.34h0l-.11-.11a1.74,1.74,0,0,1-.4-1.75,1,1,0,0,1,.78-.51h6.9V13.15H102.11a3.39,3.39,0,0,0-3.39,3.39h0a3.5,3.5,0,0,0,.72,2.09l.27.38,7.18,8.58h0l1.55,1.89H99.12V30h0v7.57H115.4a5.1,5.1,0,0,0,5.11-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005172",
    "data-name": "Tracciato 199",
    d: "M63.76,37.59V29.5H54.42l7.31-8.66a12.72,12.72,0,0,0-11.36-8.68h-.72a12.76,12.76,0,0,0-1.73,25.4h.21a9.62,9.62,0,0,0,1.52.09H63.76ZM46.08,28a4.74,4.74,0,0,1,6-7.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#005172",
    "data-name": "Rettangolo 4",
    x: 83.77,
    y: 13.15,
    width: 10.65,
    height: 24.44
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#005172",
    "data-name": "Rettangolo 5",
    x: 83.77,
    width: 10.65,
    height: 8.13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005172",
    "data-name": "Tracciato 200",
    d: "M0,0V13.42a22.34,22.34,0,0,0,2.14,9.19L15.52,6.18,28.88,22.61A22.34,22.34,0,0,0,31,13.42V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#005172",
    "data-name": "Tracciato 201",
    d: "M4.49,27.06a36.62,36.62,0,0,0,11,10.53,36.81,36.81,0,0,0,11-10.53c-.46-.57-9.63-11.6-11-13.26C14.12,15.46,5,26.53,4.49,27.06Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondazioneElis);
export default __webpack_public_path__ + "static/media/fondazione_elis.a332604d60153c8a8f4bfb1097ac8382.svg";
export { ForwardRef as ReactComponent };